import { connect } from "react-redux";
import CampaignCreation from './CampaignCreation'
import { bindActionCreators } from "redux";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";
import { addCampaignData } from 'services/redux/brandActivtion/adsCampaign/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    createAdsCampaign: state.campaignReducer.createAdsCampaign,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        addCampaignData,
        documentUploadUrlPublic
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCreation);